import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { intlShape } from 'react-intl'
import AlbumCard from './AlbumCard'

import * as shapes from '../../constant/shapes'

import { getArtist as getArtistAction } from './artistActions'
import * as selectors from './artistSelectors'
import appConst from '../../constant/appConst'
import { Link } from 'react-router'
import TrackList from '../../components/tracklist/TrackList'
import { clearPlayqueue as clearPlayqueueAction } from '../../components/miniPlayer/AudioPlayer/playerActions'
import Loader from '../../components/loader/Loader'
import redirectToApp from '../../utils/redirectToApp'
import { Helmet } from 'react-helmet'
import * as playerSelectors from '../../components/miniPlayer/miniPlayerSelectors'
import * as constant from '../../components/miniPlayer/AudioPlayer/playerConstants'

const fields = [{
	type: 'cover',
	render: track => <img src={track.cover} alt="" height="40" width="40" />
},{
	type: 'name',
	render: track => <Link to={`/track/${track.id}`}>{track.title}</Link>
}, {
	type: 'album',
	render: track => <Link to={`/album/${track.albumId}`}>{track.album}</Link>
}, {
	type: 'time',
	render: track => `${`0${Math.floor(track.duration / 60)}`.substr(-2)}:${`0${track.duration % 60}`.substr(-2)}`
}]

class ArtistPage extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			fullDescription: false,
			defaultCardHeight: null,
			defaultImageHeight: null
		}
		this.toggleFullDescription = this.toggleFullDescription.bind(this)
		this.setCardsSizes = this.setCardsSizes.bind(this)
		this.onResize = this.onResize.bind(this)
	}

	componentWillMount() {
		const { id, getArtist } = this.props
		getArtist(id, 0, 10)
	}

	componentDidMount() {
		this.setCardsSizes()
		window.addEventListener('resize', this.onResize, false)
	}

	componentWillUnmount() {
		this.props.clearPlayqueue()
		window.removeEventListener('resize', this.onResize, false)
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.id !== nextProps.id) this.props.clearPlayqueue()
	}

	toggleFullDescription() {
		this.setState({
			fullDescription: !this.state.fullDescription
		})
	}

	onResize() {
		this.setCardsSizes()
	}

	setCardsSizes() {
		const metaHeight = 54
		const albums = document.querySelectorAll('.albums-generic-grid-list > .item')
		if (albums) {
			const firstAlbum = albums[0]
			if (firstAlbum) {
				const cardWith = +firstAlbum.clientWidth
				this.setState({
					defaultImageHeight: cardWith - 2, // 1px border
					defaultCardHeight: cardWith + metaHeight
				})
			}
		}
	}

	render() {
		const { id, infos, albums, isCurrentTrack, isPlaying } = this.props
		const { intl } = this.context
		const showDisplayFull = !this.state.fullDescription && (infos.description || '').length > appConst.descriptionMaxLength

		return (
			<Loader>
				<div className="content mt40">
					<Helmet>
						<title>{intl.formatMessage({ id: "title.artist" }, { artistName: infos.name })}</title>
					</Helmet>
					<div className="artist-background" style={{ backgroundImage: `url(${infos.image})` }} />
					<div className="artist-background-overlay" />
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<div className="artist-cover-content">
									{infos.image ? <div className="artist-cover" style={{ backgroundImage: `url(${infos.image})` }} title={infos.name}></div> : <span className="pct pct-artist artist-no-cover" />}
								</div>
								<div className="text-center mb50">
									<h1 className="t4 text-bold mb10">{infos.name}</h1>
									<p className="c2 mb20">
										<span className="pct pct-disc" /> {intl.formatMessage({ id: 'infos.diskCount' }, { count: `${infos.nbDisques}` })}
									</p>
									<a onClick={() => redirectToApp('artist', id)} className="bt7">{intl.formatMessage({ id: 'buttons.listen' })}</a>
								</div>
								<div {...(!this.state.fullDescription ? { className: 'artist-desc mb10' } : { className: 'mb10' })}
									dangerouslySetInnerHTML={{ __html: (infos.description ? `${infos.description}` : '').nl2br() }}
								/>
								{showDisplayFull && <p className="mb40">
									<a onClick={this.toggleFullDescription} className="c2">
										{intl.formatMessage({ id: 'buttons.readmore' })}
										&nbsp;<span className="pct pct-carret-link t7" />
									</a>
								</p>}
								{this.state.fullDescription && <p>
									<a onClick={this.toggleFullDescription} className="c2">
										<span className="pct pct-reverse-carret-link t7" />&nbsp;
										{intl.formatMessage({ id: 'buttons.showless' })}
									</a>
								</p>}
							</div>
						</div>
						{infos.hasTopTracks && <section className="top-item">
							<h2 className="t2 c2">{intl.formatMessage({ id: 'tracklist.title.artist' })}</h2>
							<TrackList
								fields={fields}
								listContainerClassName=""
								listClassName="track-list no-cache"
							/>
						</section>}
						<section className="item-list mt40">
							<h2 className="t2 c2">{intl.formatMessage({ id: 'tracklist.title.artist_albums' })}</h2>
							<div className="item-list-grid albums-generic-grid-list">
								{albums.map(album => <AlbumCard
									forceCardHeight={this.state.defaultCardHeight}
									forceImageHeight={this.state.defaultImageHeight}
									key={`album-${album.id}`}
									current={isCurrentTrack(constant.ORIGIN_PLAYQUEUE_TYPES.album, album.id)}
									playing={isPlaying}
									album={album}
								/>)}
							</div>
							{infos.nbDisques > 10 &&
							<div className="text-center mb20">
								<a onClick={() => redirectToApp('artist', id)} className="bt7">{intl.formatMessage({ id: 'buttons.showmore' })}</a>
							</div>}
						</section>
					</div>
				</div>
			</Loader>
		)
	}
}

ArtistPage.propTypes = {
	id: PropTypes.string,
	infos: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		nbDisques: PropTypes.number,
		description: PropTypes.string,
		image: PropTypes.string,
		hasTopTracks: PropTypes.bool
	}),
	albums: PropTypes.arrayOf(shapes.albumCard),
	isCurrentTrack: PropTypes.func,
	isPlaying: PropTypes.bool,
	getArtist: PropTypes.func,
	clearPlayqueue: PropTypes.func
}

ArtistPage.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state, ownProps) => ({
	id: ownProps.params.id,
	infos: selectors.getArtistInfos(state),
	albums: selectors.getArtistAlbums(state),
	isCurrentTrack: playerSelectors.isCurrentTrack(state),
	isPlaying: playerSelectors.isPlaying(state)
})

const actions = {
	getArtist: getArtistAction,
	clearPlayqueue: clearPlayqueueAction
}

export default connect(mapStateToProps, actions)(ArtistPage)



// WEBPACK FOOTER //
// ./src/pages/artist/ArtistPage.jsx